// extracted by mini-css-extract-plugin
module.exports = {"headerCompactSpacing":"password-reset-success_headerCompactSpacing__7_6qG","body":"password-reset-success_body__9Yulx","link":"password-reset-success_link__a2atn"};